import React from 'react';

export function Button({ variant = 'primary', size = 'md', children, className = '', ...props }) {
  const baseStyle = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-50 disabled:pointer-events-none ring-offset-background';
  
  const variants = {
    primary: 'bg-primary text-white hover:bg-primary/90',
    secondary: 'bg-secondary text-foreground hover:bg-secondary/80',
    outline: 'border border-border hover:bg-secondary',
    ghost: 'hover:bg-secondary hover:text-foreground',
  };

  const sizes = {
    sm: 'h-9 px-3 rounded-md',
    md: 'h-10 py-2 px-4',
    lg: 'h-11 px-8 rounded-md',
    icon: 'h-10 w-10',
  };

  const variantClass = variants[variant] || variants.primary;
  const sizeClass = sizes[size] || sizes.md;

  return (
    <button className={`${baseStyle} ${variantClass} ${sizeClass} ${className}`} {...props}>
      {children}
    </button>
  );
}
